import { render, staticRenderFns } from "./AvantiSlingshot.vue?vue&type=template&id=c144ac58&scoped=true&"
import script from "./AvantiSlingshot.vue?vue&type=script&lang=js&"
export * from "./AvantiSlingshot.vue?vue&type=script&lang=js&"
import style0 from "./AvantiSlingshot.vue?vue&type=style&index=0&id=c144ac58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c144ac58",
  null
  
)

export default component.exports